import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import * as _ from "lodash";
import { ProductionShopFloorWorkOrders } from "src/app/services/service/DataProviders/ProductionShopFloorWorkOrders";
import { GeneralDocumentsDocuments, DocumentTreeNode } from "src/app/services/service/DataProviders/GeneralDocumentsDocuments";
import { ChangeStatus } from "src/app/main-functions/change-status";

@Component({
  selector: "app-change-status",
  templateUrl: "./change-status.component.html",
  styleUrls: ["./change-status.component.scss"],
})
export class ChangeStatusComponent implements OnInit {
  public filterForm: FormGroup = new FormGroup({
    DocumentNo: new FormControl("", [Validators.required]),
  });

  public poList: any[] = [];
  public productionOrder: any = null;
  public tree: DocumentTreeNode | null = null;
  public treeForView: DocumentTreeNode[] = [];

  public loading = false;
  public error: string | null = null;
  public disableProcessButton = false;

  public executionLog;

  constructor(
    private woService: ProductionShopFloorWorkOrders,
    private documentsService: GeneralDocumentsDocuments,
    public changeStatusService: ChangeStatus
  ) {}

  ngOnInit(): void {
    this.executionLog = this.changeStatusService.subscribeForLog();
  }

  search() {
    if (this.filterForm.invalid) {
      return;
    }

    this.error = null;
    this.tree = null;
    this.treeForView = [];
    this.poList = [];
    this.productionOrder = null;

    const documentNo = this.filterForm.value.DocumentNo;
    this.woService.findByNumber(documentNo).subscribe(
      (res: any) => {
        if (!_.isArray(res.value) || res.value.length == 0) {
          this.error = "Не е намерено ПН с номер " + documentNo;
          return;
        }

        if (res.value.length == 1) {
          this.selectPoFromMultiple(res.value[0]);
        } else {
          this.poList = res.value;
        }
      },
      (error) => {
        console.error(error);
        this.error = "Грешка при търсене на ПН";
      }
    );
  }

  selectPoFromMultiple(po) {
    this.productionOrder = po;
    this.poList = [];
    this.loadTree();
  }

  private loadTree() {
    this.loading = true;
    const entityName = _.get(this.productionOrder, "EntityName", null);
    this.documentsService
      .getDocumentsTreeByParentRelation(this.productionOrder, entityName)
      .then((res) => {
        this.tree = res;
        this.treeForView = res ? [res] : [];
        this.loading = false;
      })
      .catch((error) => {
        console.error(error);
        this.error = "Грешка при зареждане на документите";
        this.loading = false;
      });
  }

  getChildrens = (node: DocumentTreeNode) => node.children;

  onSystemStatusChange(node: DocumentTreeNode) {
    node.document._pendingUserStatusName = null;
    node.document._pendingUserStatus = null;
    node.document._invalid = false;
    node.document._invalidReason = null;
    node.document._skippedLowerOrder = false;
  }

  getUserStatusOptions(node: DocumentTreeNode) {
    return this.changeStatusService.getUserStatusOptions(node, node.document._pendingState);
  }

  onUserStatusChange(node: DocumentTreeNode) {
    const state = node.document._pendingState;
    const userStatusName = node.document._pendingUserStatusName;
    if (!state || !userStatusName) {
      return;
    }
    this.changeStatusService.applyStatusCascade(node, state, userStatusName);
  }

  get canProcess(): boolean {
    return this.changeStatusService.canProcess(this.tree);
  }

  async processChanges() {
    if (!this.tree) {
      return;
    }
    this.disableProcessButton = true;
    await this.changeStatusService.processTree(this.tree);
    this.disableProcessButton = false;
  }

  resetSearch() {
    this.filterForm.reset();
    this.tree = null;
    this.treeForView = [];
    this.productionOrder = null;
    this.poList = [];
    this.error = null;
  }

  // ВРЕМЕННО (еднократно): търси надолу от 0000001900 за ПН с подпроизводствени нареждания, резултатът отива в конзолата
  private findByNumberAsync(documentNo: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.woService.findByNumber(documentNo).subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  public async findPoWithChildren() {
    let docNo = 1882;

    while (docNo >= 1) {
      const formatted = String(docNo).padStart(10, "0");
      console.log("Проверявам ПН", formatted);

      try {
        const res: any = await this.findByNumberAsync(formatted);
        if (_.isArray(res.value) && res.value.length > 0) {
          const po = res.value[0];
          const entityName = _.get(po, "EntityName", null);
          const tree = await this.documentsService.getDocumentsTreeByParentRelation(po, entityName);
          if (tree && _.isArray(tree.children) && tree.children.length > 0) {
            console.log("Намерено ПН с подпроизводствени нареждания:", formatted);
            return formatted;
          }
        }
      } catch (e) {
        console.error("Грешка при проверка на ПН", formatted, e);
      }

      docNo--;
    }

    console.log("Не е намерено ПН с деца в зададения диапазон");
    return null;
  }
}
